export const SITE_NAME = 'Fast Fares';
export const SITE_DOMAIN = 'fastfares.info';
export const SITE_URL = 'https://fastfares.info/flight';
export const SITE_TAGLINE = 'Book Affordable Flights & Hotels';

/** Header / nav CTA label */
export const MY_BOOKINGS_LABEL = 'My Bookings';

/** 24/7 flight support (isolated /flight experience) */
export const PHONE = '1-888-401-4158';
export const PHONE_RAW = '+18884014158';
/** Primary contact (Nodex Global LLC) */
export const EMAIL = 'info@nodexgloballlc.com';

/** Legal operator (Nodex Global LLC) */
export const COMPANY_NAME = 'Nodex Global LLC';
export const COMPANY_EMAIL = 'info@nodexgloballlc.com';
export const ADDRESS_LINE1 = '32 N Gould St.';
export const ADDRESS_LINE2 = 'Sheridan, WY 82801';
/** Single-line form (search, metadata, aria) */
export const ADDRESS = `${ADDRESS_LINE1} ${ADDRESS_LINE2}`;

export const COPYRIGHT_START = 2024;
export const COPYRIGHT_END = 2026;

/** Shown in header top bar */
export const AFFILIATE_DISCLOSURE =
  'Nodex Global LLC is an independent travel advisory company affiliated with Fora Travel.';

export const FOOTER_DISCLAIMER = [
  `${COMPANY_NAME} is an independent travel advisory company affiliated with Fora Travel. We provide travel planning, booking assistance, and concierge-style travel services for flights, hotels, vacation packages, cruises, and other travel experiences.`,
  'We serve as an intermediary between customers and travel suppliers. All reservations are subject to supplier availability, fare rules, cancellation policies, and applicable terms and conditions.',
  'Our customer support team is available seven days a week for booking assistance and post-booking support.',
];
